import { Component, OnInit } from '@angular/core';
import { companyListService } from "./company-list.service";
import { Router } from '@angular/router';
import { CommonService } from "@app/shared/common/common.service";

@Component({
  selector: 'sa-company-list',
  templateUrl: './company-list.component.html',
  providers: [companyListService]
})
export class companyListComponent implements OnInit {

  companies: Array<any>;
  activeCompanName;
  constructor(private companyListService: companyListService, 
              private router: Router,
              private commonService: CommonService) {
    this.companies = [];
    this.activeCompanName = '';
  }

  ngOnInit() {
    let data= new FormData();
    data.append('instanceId',localStorage.getEncryptedItem('instanceId'))
    data.append('userId',localStorage.getEncryptedItem('loginId'))
    data.append('companyUserId',localStorage.getEncryptedItem('companyUserId'))
		data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    let object = this.commonService.createObject(data)
    let token = this.commonService.createToken(object)
    let encryptedToken = this.commonService.encrypt(token)
    let encrData = new FormData()
    encrData.append("encrToken", encryptedToken);
    this.companyListService.getClientDropdown(encrData).subscribe((data:any) =>{
      if(!data.status && data.isUnauthenticated) {
				this.commonService.logout();				
				return false;
			}
      localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
      if(data.DATA.length>0){
        this.activeCompanName = localStorage.getEncryptedItem('companyName');
        this.companies = data.DATA;
      }
    })
  }

  clearProjects() {
    this.companyListService.clearProjects();
  }

  changeCompany(comp) {
    let data= new FormData();
    data.append('instanceId',localStorage.getEncryptedItem('instanceId'))
    data.append('companyUserId',comp.COMPANYUSERID)
    data.append('userId',localStorage.getEncryptedItem('loginId'))
		data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    let url = this.router.url.split('/')[1];
    this.companyListService.changeClient(data).subscribe((data:any) =>{
      if(!data.status && data.isUnauthenticated) {
				this.commonService.logout();
				
				return false;
			}
      localStorage.setEncryptedItem('loginId',data.DATA.USERID);
      localStorage.setEncryptedItem('userName',data.DATA.USERNAME);
      localStorage.setEncryptedItem('firstName',data.DATA.FIRSTNAME);
      localStorage.setEncryptedItem('name',data.DATA.NAME);
      localStorage.setEncryptedItem('companyName',data.DATA.COMPANYNAME);
      localStorage.setEncryptedItem('companyUserId',data.DATA.COMPANYUSERID);
      localStorage.setEncryptedItem('companyId',data.DATA.COMPANYID);
      localStorage.setEncryptedItem('profileImage',data.DATA.PROFILEIMAGE);
      // let defaultModule = this.commonService.getDefaultUrl();
      if(url !== "settings"){
        this.router.navigate(['invoice/dashboard']);
      } else {
        this.router.navigate(['/' + url + '/' + 'usermanager/myprofile']);
      }
      let formData= new FormData();
      formData.append('instanceId',localStorage.getEncryptedItem('instanceId'))
      formData.append("companyUserId",localStorage.getEncryptedItem('companyUserId'))
      formData.append('userId',localStorage.getEncryptedItem('loginId'))
      formData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      let object = this.commonService.createObject(formData)
      let token = this.commonService.createToken(object)
      let encryptedToken = this.commonService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      setTimeout(()=>{
        window.location.reload();
        this.companyListService.getUserRights(encrData).subscribe((res:any) =>{
          if(!res.status && res.isUnauthenticated) {
            this.commonService.logout();
            
            return false;
          }
          let right = String(res.DATA)
          
          let userRights = this.commonService.encrypt(right);
          localStorage.setEncryptedItem('userRights',userRights);
        });
        
        var settingsData = new FormData();
        settingsData.append("instanceId", localStorage.getEncryptedItem('instanceId'));
        settingsData.append("companyId",localStorage.getEncryptedItem('companyId'));
        settingsData.append('userId',localStorage.getEncryptedItem('loginId'));
        settingsData.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
        settingsData.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
        let objectSettings = this.commonService.createObject(settingsData)
        let tokenSettings = this.commonService.createToken(objectSettings)
        let encryptedTokenSettings = this.commonService.encrypt(tokenSettings)
        let encrDataSettings  = new FormData()
        encrDataSettings .append("encrToken", encryptedTokenSettings);
        // this.authenticationService.getSettings(encrDataSettings).subscribe(res =>{ 
        //     localStorage.setEncryptedItem("lastRequestTime",res.RESPONSETIME);
        //     let moduleSettings = JSON.stringify(res.DATA);
        //     localStorage.setEncryptedItem('moduleSettings',moduleSettings);
        // });
      });
      
    })
  }
}
